module.exports = __webpack_public_path__ + "img/catalog.a144daf3.png";